import MicroModal from 'micromodal/dist/micromodal.min'
import {Swiper, Navigation, EffectFade} from 'swiper/dist/js/swiper.esm.js'

window.MicroModal = MicroModal;
Swiper.use([Navigation, EffectFade]);

/*const modalConfig = {
  disableScroll: true,
  awaitOpenAnimation: true,
  awaitCloseAnimation: true,
  onShow: modal => {
    const container = modal.querySelector('.modal__container');
    // console.log(container.scrollHeight);
    // console.log(container.offsetHeight);

    if (container.scrollHeight <= container.offsetHeight) {
      container.classList.add('v-center')
    }
    modal.dispatchEvent(new CustomEvent("modal-open", { bubbles: true }));
  }
};

MicroModal.init(modalConfig);*/

//показывает окно успешной регистрации/авторизации после перезагрузки страницы
function showSuccessModal(modalName, modalHTML) {
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    MicroModal.show(modalName, Object.assign(modalConfig, {
      onClose: () => {
        window.history.pushState("", document.title, window.location.pathname);
      }
    }));
}
if (location.hash === `#register=true`) {
  import(/* webpackChunkName: "modal-register-ok" */ `./modal-register-ok.pug?static`).then(module => showSuccessModal('modal-register-ok', module.default));
}
if (location.hash === `#login=true`) {
  import(/* webpackChunkName: "modal-login-ok" */ `./modal-login-ok.pug?static`).then(module => showSuccessModal('modal-login-ok', module.default));
}

//инициализирует слайдер после открытия окна
(function () {
  const sliderFunc = () => {
    const sliderEl = document.querySelector('.slider-modal-gallery');
    if (!sliderEl) return;
    new Swiper(sliderEl, {
        speed: 500,
        autoplay: {
          delay: 5000,
        },
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: sliderEl.querySelector('.swiper-button-next'),
          prevEl: sliderEl.querySelector('.swiper-button-prev'),
        },
      }
    );
  };
  document.addEventListener('modal-open', e => {
    const modal = e.target;
    if (modal.id === 'modal-gallery') {sliderFunc()}
  })
})();
